import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { alertActions } from "../redux/AlertController";
import useLogout from "./useLogout";

export const useGroups = () => {
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCreating, setIsCreating] = useState(false);

    const dispatch = useDispatch();
    const user = useSelector(state => state.userController.user);
    const navigate = useNavigate();
    const { logout } = useLogout();

    const fetchGroups = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/groups`, {
                headers: { 'Authorization': `Bearer ${user?.token}` }
            });
            const json = await res.json();

            if (res.status === 401) {
                logout();
            } else if (!res.ok) {
                dispatch(alertActions.showAlert({ msg: json.message, type: 'error' }));
            } else {
                setGroups(json.groups);
            }
        } catch (err) {
            dispatch(alertActions.showAlert({ msg: err.message, type: 'error' }));
        }
        setIsLoading(false);
    };

    const createGroup = async (description) => {
        setIsCreating(true);
        let success = false;
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/groups`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.token}`
                },
                body: JSON.stringify({ description })
            });
            const json = await res.json();

            if (res.status === 401) {
                logout();
            } else if (!res.ok) {
                dispatch(alertActions.showAlert({ msg: json.message, type: 'error' }));
            } else {
                dispatch(alertActions.showAlert({ msg: 'تم إنشاء المجموعة بنجاح', type: 'success' }));
                success = true;
                fetchGroups();
            }
        } catch (err) {
            dispatch(alertActions.showAlert({ msg: err.message, type: 'error' }));
        }
        setIsCreating(false);
        return success;
    };

    useEffect(() => {
        if (!user) {
            navigate('/login');
        } else {
            fetchGroups();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return { groups, isLoading, fetchGroups, createGroup, isCreating };
};
